export const IconRedo = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M16.2 10H9.9q-1.575 0-2.738 1Q6 12 6 13.5T7.162 16q1.164 1 2.738 1H16q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 16 19H9.9q-2.425 0-4.163-1.575Q4 15.85 4 13.5t1.737-3.925T9.9 8h6.3l-1.9-1.9a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l3.6 3.6q.15.15.212.325.063.176.063.375 0 .2-.062.375a.9.9 0 0 1-.213.325l-3.6 3.6a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.425.275-.7z" />
    </svg>
  );
};
